// Author THQ
// Date 2025-03-09 00:57:26

import * as model from "@/model/em/ppe/PpeApplyRecordHistoryModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PpeApplyRecordHistory(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_PPE_URL,
    })
    .buildStore()
